export default "__VITE_ASSET__bbdk71Bz__"